<template>
    
        <PButton :disabled="isDisabled" :loading="loading" @paste.prevent v-on:click="acao" :class="`g-button g-button-container ${sombreado ? 'g-button-sombreado' : ''}`">
            <div class="g-button-agrupar">
                <div class="g-button-icone-esquerda" v-if="icone">
                    <img v-if="iconeEhSvg" class="g-button-img-icone-esquerda" :src="require(`@/assets/imgs/${icone}`)" />
                    <i v-else :class="icone + ' g-button-img-icone-esquerda'" :style="`color: #${corIconeClass};`"></i>
                </div>
                <div class="g-button-texto">
                    <slot></slot>
                </div>
            </div>
        </PButton>
</template>

<script>
    import gButton from './g-button.js'
    export default gButton
</script>

<style scoped>

.g-button{
    background-color: v-bind('backgroundColor');
    min-height: v-bind('minAltura');
    border-radius: 8px;
    user-select: auto;
}
:deep(.g-button.p-button){
    box-shadow: none !important;
    padding: 0px !important;
}

.g-button-container{
    width: v-bind('largura');
    height: v-bind('altura');
}

.g-button-container .g-button{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.p-button{
    background-color: v-bind('backgroundColor');
    color: v-bind('corDoTexto');
    font-family: v-bind('fontTexto');
    border: v-bind('bordabotao');
    border-color: v-bind('corbordabotao');
}

.p-button:hover{
    background-color: v-bind('backgroundColor') !important;
    border: v-bind('bordabotao');
}

.g-button-texto {
    font-size: v-bind('tamanhoTexto');
    color: v-bind('corDoTexto');
    font-weight: v-bind('weightTitulo');
}

.g-button-img-icone-esquerda{

    width: v-bind('tamanhoIcone');
    font-size: v-bind('tamanhoIcone');
    color: #ffffff;
    /* color: v-bind('corIcone'); */
}

.g-button-icone-esquerda{
    display:flex;
    align-items: center;
    justify-content: center;
}

.g-button-agrupar{
    display: flex;
    justify-content: center;
    width: 100%;
    gap: v-bind('gap');
}

:deep(.g-button.p-button.g-button-sombreado){
    box-shadow: 0px 4px 5px 3px rgba(0, 0, 0, 0.2) !important;
}

</style>
